module.exports = __webpack_public_path__ + "static/media/error.eabe7468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.svg
// module id = 231
// module chunks = 0